"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bus_rdf_metadata_extract_1 = require("@comunica/bus-rdf-metadata-extract");
/**
 * An RDF Metadata Extract Actor that extracts total items counts from a metadata stream based on the given predicates.
 */
class ActorRdfMetadataExtractHydraCount extends bus_rdf_metadata_extract_1.ActorRdfMetadataExtract {
    constructor(args) {
        super(args);
    }
    async test(action) {
        return true;
    }
    run(action) {
        return new Promise((resolve, reject) => {
            // Forward errors
            action.metadata.on('error', reject);
            // Immediately resolve when a value has been found.
            action.metadata.on('data', (quad) => {
                if (this.predicates.indexOf(quad.predicate.value) >= 0) {
                    resolve({ metadata: { totalItems: parseInt(quad.object.value, 10) } });
                }
            });
            // If no value has been found, assume infinity.
            action.metadata.on('end', () => {
                resolve({ metadata: { totalItems: Infinity } });
            });
        });
    }
}
exports.ActorRdfMetadataExtractHydraCount = ActorRdfMetadataExtractHydraCount;
//# sourceMappingURL=ActorRdfMetadataExtractHydraCount.js.map